const len_formatter = (row, column) => {
    const value = row[column.property]
    return value.length || 0
}

const name_formatter = (row, column) => {
    const value = row[column.property]
    return value.substring(0,1) + new Array(value.length).join('*')
}

const data = {
    table: {
        columns: [
            {title: '体检机构', field: 'hospital.name', width: '140'},
            {title: '体检编号', field: 'code', width: '140'},
            {title: '姓名', field: 'name', width: '100', formatter: name_formatter},
            {title: '性别', field: 'gender', width: '80'},
            {title: '年龄', field: 'age', width: '80'},
            {title: '费用金额', field: 'fee', width: '180'},
            {title: '项目数量', field: 'jcxm', width: '180', formatter: len_formatter},
            {title: '体检日期', field: 'jdrq', width: '180'},
            {title: '备注', field: 'remarks', width: ''}
        ],
        data: [],
        total: 0,
        page: 1,
        pageSize: 20
    }
}

export default data
